<!--View for chat. It contains left (chat list), 
middle(messages and messageinput) and right(owner/pet detaild and other buttonsside of the front page -->

<template>
    <div class="chat">
      <Heading/>
      <div class="flex flex-auto">
        <Sidebar :queue="selectedQueue" :enabledQueues="enabledQueues" :createLinkTo="createLinkTo" />
        <div class="main">

          <div v-if="!chat || (!messages.length && ['new', 'appointment'].includes(effectiveInfoTextQueue))" class="flex-auto flex items-center h100 justify-center overflow-y">
            <div class="max-width-1 center gray-3 h2">
              <svg class="mb3" width="68" height="68" viewBox="0 0 68 68" xmlns="http://www.w3.org/2000/svg">
                <g stroke="#A3ADB3" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linejoin="round">
                  <path d="M67 34c0 18.225-14.778 33-33 33C15.772 67 1 52.225 1 34S15.772 1 34 1c18.222 0 33 14.775 33 33zM25 55h18" stroke-linecap="round"/>
                  <path stroke-linecap="round" d="M28 28h6v25.5"/>
                  <path d="M32.5 15a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 32.5 15z"/>
                </g>
              </svg>

              <div v-if="['new', 'own', 'closed'].includes(effectiveInfoTextQueue)">
                <p v-if="chat">
                  {{petSpecies}}, {{chat.pet.breed}}.<br>
                  Oikean reunan paneelista näet eläimen tiedot.
                </p>
                <p v-if="effectiveInfoTextQueue === 'new'">
                  Voit aloittaa keskustelun ottamalla sen käsittelyyn.
                </p>
                <p v-if="!chat">
                  Valitse keskustelu vasemman reunan paneelista.
                </p>
              </div>
              <div v-else-if="effectiveInfoTextQueue === 'appointment'">
                <p>
                  Jos jonossa on klinikallesi tulossa olevia lemmikkejä, soita asiakkaalle ja varaa aika. Löydät puhelinnumeron omistajan tiedoista.
                </p>
                <p>
                  Kun aika on varattu, vie lemmikin tiedot Provetiin klinikkakäyntiä odottamaan ja sulje käsittely, jotta lemmikki poistuu jonosta.
                </p>
              </div>
              <div v-else-if="!effectiveInfoTextQueue">
                <p>
                  Sinulla ei ole käyttöoikeuksia nähdä keskusteluja.
                </p>
              </div>
            </div>
          </div>
          <ChatArea v-else :chat="chat" :messages="messages" />

        </div>
        <RightBar v-if="chat" :chat="chat" :messages="messages" :details="details" :createLinkTo="createLinkTo" />
      </div>
    </div>
</template>

<script>

import { mapGetters } from "vuex";

import Heading from '@/components/Heading.vue';
import ChatArea from '@/components/reception/ChatArea.vue';
import Sidebar from '@/components/reception/Sidebar.vue';
import RightBar from '@/components/reception/RightBar.vue';
import router, { createLinkToChat } from '@/router';
import Button from '@/components/Button.vue';
import Util from '@/util';

export default {
  name: 'Chat',
  components: { Heading, Sidebar, ChatArea, RightBar,
    'v-button': Button,
  },
  props: {
    chatId: String,
    queue: {
      type: String,
      default: 'new',
      validator: (val) => ['new', 'appointment', 'own', 'closed'].includes(val),
    },
    details: {
      type: String,
      default: 'pet',
      validator: (val) => ['pet', 'questionnaire'].includes(val),
    },
  },
  computed: {
    chat() {
      return this.chatById(this.chatId);
    },
    messages() {
      return this.chatMessagesById(this.chatId);
    },
    unseenMessages() {
      return this.chatUnseenMessagesById(this.chatId);
    },
    enabledQueues() {
      return [
        ...(this.profile.iam.chatRead ? ['new', 'own', 'closed'] : []),
        ...(this.profile.iam.chatAppointment ? ['appointment'] : []),
      ];
    },
    selectedQueue() {
      return this.enabledQueues.includes(this.queue) ? this.queue : this.enabledQueues[0];
    },
    effectiveInfoTextQueue() {
      return (this.chat && this.chat.queue) || this.selectedQueue;
    },
    petSpecies() {
      return Util.mapSpecies(this.chat.pet.species);
    },

    ...mapGetters({
      chatById: 'chatById',
      chatMessagesById: 'chatMessagesById',
      chatUnseenMessagesById: 'chatUnseenMessagesById',
      connected: 'connected',
      profile: 'profile',
    })
  },
  watch: {
    queue: {
      immediate: true,
      handler(value) {
        this.$store.dispatch('getChats');

        if (value === 'appointment') {
          this.$store.dispatch('getClinics');
        }
      },
    },
    chat: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue) {
          const {
            chatId,
          } = newValue;

          if (!oldValue || oldValue.chatId !== chatId) {
            this.$store.dispatch('loadMessages', chatId);
          }
        }
      },
    },
    connected: {
      immediate: true,
      handler(value) {
        if (value && this.chat) {
          this.$store.dispatch('loadMessages', this.chat.chatId);
        }
      },
    },
    unseenMessages(value) {
      if (value) {
        this.$store.commit('RESET_CHAT_UNSEEN_MESSAGES', {
          chatId: this.chatId,
        });
      }
    },
  },
  methods: {
    createLinkTo(params) {
      return createLinkToChat({
        queue: this.queue,
        chatId: this.chatId,
        details: this.details,

        ...params,
      });
    },
  },
}

</script>

<style scoped>
  .chat {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
  }

  .main {
    overflow: hidden;
    background-color: #fff;
    flex: auto;
  }

  .text {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
  }
</style>
